import { Component, inject, Input, OnInit } from '@angular/core';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonLabel } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003601CapteurTemperatureEnum } from '../../../Enum/P0003601CapteurTemperatureEnum';
import { P0003601SeuilTemperatureHorsGel } from '../../../Enum/P0003601SeuilTemperatureHorsGel';

@Component({
  selector: 'app-p0003601-filtration-mise-en-oeuvre-prevention-gel',
  templateUrl:
    './p0003601-filtration-mise-en-oeuvre-prevention-gel.component.html',
  styleUrls: [
    './p0003601-filtration-mise-en-oeuvre-prevention-gel.component.scss',
  ],
  imports: [
    AffichageWarningComponent,
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    IonLabel,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    TranslatePipe,
  ],
})
export class P0003601FiltrationMiseEnOeuvrePreventionGelComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  hasProduitP00030() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00030()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003601CapteurTemperatureEnum =
    P0003601CapteurTemperatureEnum;
  protected readonly P0003601SeuilTemperatureHorsGel =
    P0003601SeuilTemperatureHorsGel;
}
